import React, { useState, useEffect } from "react";
import { noImg } from "vrcore-dashboard/dist/utilities";
import { Grid, Typography } from "@material-ui/core";

export default (props) => {
    const [profile, setProfile] = useState(props.profile);

    useEffect(() => {
        setProfile(props.profile);
    }, [props.profile]);
    const { attached_photos = [] } = profile;
    return (
        <Grid item xl={12} xs={12}>
            <Typography
                style={{ marginLeft: 24, marginBottom: 30 }}
                variant="h5"
            >
                Attached Photo's:
            </Typography>
            <Grid container spacing={4}>
                {attached_photos &&
                    attached_photos.map((e, i) => {
                        return (
                            <Grid
                                xl={3}
                                lg={3}
                                xs={3}
                                sm={3}
                                md={3}
                                style={{ position: "relative" }}
                            >
                                <img
                                    style={{
                                        padding: "7px",
                                        borderRadius: "32px",
                                        width: "100%",
                                        height: "auto",
                                    }}
                                    src={e ? e : noImg}
                                    alt={e ? e : noImg}
                                />
                            </Grid>
                        );
                    })}
            </Grid>
        </Grid>
    );
};
